import './index.css';
import './tw.css';

// this import is required to fix the issue with react 19 and antd v5 (https://ant.design/docs/react/v5-for-19)
import '@ant-design/v5-patch-for-react-19';

import React, { useState } from 'react';

import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import 'ckeditor5/ckeditor5.css';
import 'react-tagsinput/react-tagsinput.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-loading-skeleton/dist/skeleton.css';
import { i18n } from 'locales/i18n';
import { sagaMiddleware } from 'store';
import sagas from 'store/sagas';
import ScrollToTop from 'components/layout/ScrollToTop/ScrollToTop';
import App from 'components/App/App';
import { setupOpenFeature } from 'providers/openFeatureProvider';
import { DEFAULT_DISPLAY_LANGUAGE } from 'config/languages';

import setupRUM from './cloudWatchRUM/setupRUM';
import './cloudWatchRUM/logger';
import setupSentry from './sentry/setupSentry';
import { analytics } from './segmentAnalytics';
import * as serviceWorker from './serviceWorker';

// setup Sentry as early as possible so it can capture subsequent errors
setupSentry();

// Initialise Segment from the bundle and record the initial pageview. This
// replaces the inline analytics.js snippet that previously lived in index.html
// (removed so the app can ship a strict, inline-free CSP — PLAT-6095). Call
// sites already import `analytics` from segmentAnalytics; this guarantees the
// instance loads and the first page() fires on app start as before.
analytics.page();

// setup cloudWatch RUM
setupRUM();

// Setup OpenFeature with LaunchDarkly
setupOpenFeature();

// Initialize language to English
i18n(DEFAULT_DISPLAY_LANGUAGE);

// create the saga middleware
sagaMiddleware.run(sagas);

// Root Component Wrapped with BrowserRouter
const Root = () => (
  <BrowserRouter>
    <App />
    <ScrollToTop />
  </BrowserRouter>
);

// Root Component Wrapped with HistoryRouter
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(<Root />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
